export default __webpack_public_path__ + "static/media/event_sd_middle_bg.f5f19273.jpg";